/* Disabled because we are using redux toolkit */
/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';

import { AppSettingsState } from './types';
import { storeDrawerOpen } from './actions';

const initialState: AppSettingsState = {
    drawerOpen: false,
};

export const appSettingsReducer = createReducer(initialState, (builder) => {
    builder.addCase(storeDrawerOpen, (state, action) => {
        state.drawerOpen = action.payload;
    });
});
